import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { tv } from 'tailwind-variants';
import { cn } from '../../lib/utils';

const buttonVariants = tv({
  base: 'flex-row rounded-lg flex items-center justify-center gap-2 font-medium disabled:pointer-events-none disabled:opacity-60 border-2 border-solid border-transparent',
  variants: {
    variant: {
      primary:
        'bg-primary text-primary-foreground hover:bg-primary/90 border-primary hover:border-primary/90',
      default:
        'bg-primary text-primary-foreground hover:bg-primary/90 border-primary hover:border-primary/90',
      secondary:
        'bg-secondary text-secondary-text hover:bg-secondary-darker border-secondary hover:bg-secondary-darker',
      destructive:
        'bg-destructive text-destructive-text hover:bg-destructive/90 border-destructive hover:bg-destructive/90',
      destructiveOutline:
        'border-destructive-muted hover:border-solid hover:border-destructive bg-destructive-text text-destructive',
      outline:
        'bg-transparent border-primary-lighter hover:border-primary hover:border-solid text-primary',
      outlineOnPrimary:
        'bg-transparent border-secondary text-secondary hover:bg-secondary/30',
      ghost: 'bg-transparent text-primary hover:bg-muted',
      destructiveGhost: 'bg-transparent hover:bg-muted text-destructive',
      inactive: 'bg-muted text-muted-text hover:bg-muted',
    },
    size: {
      default: 'py-2.5 px-5',
      wrapped: 'p-0 m-0',
      evenDefault: 'p-2.5',
      evenSm: 'p-1.5',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});

const Button = forwardRef(
  (
    {
      className,
      onClick = () => {},
      icon,
      wide,
      heightAuto,
      alignLeft,
      withIcon,
      preview,
      share,
      tooltipIfDisabled,
      tooltipDelayHide,
      variant,
      size,
      children,
      disabled = false,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        disabled={disabled}
        ref={ref}
        {...props}
        className={cn(buttonVariants({ variant, size }), className)}
        onClick={(e) => {
          if (!disabled) onClick(e);
        }}
      >
        {children}
      </button>
    );
  },
);

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  wide: PropTypes.bool,
  heightAuto: PropTypes.bool,
  alignLeft: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
};

export default Button;
